var map = {
	"./2dmap/bing_tu_bg_in.png": "YbON",
	"./2dmap_eyes/bing_tu_bg_in.png": "vsre"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "gHLD";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/bing_tu_bg_in\.png$
// module id = gHLD
// module chunks = 2